import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { Page } from '@/shared/ui/Page';
import { PageHeader } from '@/shared/ui/PageHeader';
import { InviteLinkCard } from '@/entities/subscription/InviteLinkCard';
import { subscriptionApi } from '@/entities/subscription/api';
import { useT } from '@/shared/lib/i18n';

export function InviteMember() {
  const { id } = useParams<{ id: string }>();
  const qc = useQueryClient();
  const t = useT();

  const detailQ = useQuery({
    queryKey: ['subscription', id],
    queryFn: () => subscriptionApi.getDetail(id!),
    enabled: !!id,
  });
  const inviteQ = useQuery({
    queryKey: ['subscription-invite', id],
    queryFn: () => subscriptionApi.getInvite(id!),
    enabled: !!id,
  });

  return (
    <Page>
      <PageHeader title={<span className="font-bold text-[19px]">{t('management.addMember.title')}</span>} />
      <div className="px-[18px] pb-5 flex flex-col gap-4">
        <div className="rounded-[18px] p-4 bg-brand-green/10 border border-brand-green/25">
          <p className="text-[13px] text-text-secondary">{detailQ.data?.subscription.name ?? t('subscription.title')}</p>
          <p className="text-[24px] font-bold tracking-[-0.01em]">{t('management.addMember.invite')}</p>
          <p className="text-[13px] text-[#1c5a4a] mt-1">{t('management.addMember.hint')}</p>
        </div>
        <InviteLinkCard
          subscriptionId={id!}
          invite={inviteQ.data ?? null}
          onRevoke={() => qc.invalidateQueries({ queryKey: ['subscription-invite', id] })}
        />
      </div>
    </Page>
  );
}
